import { useGlobalContainerRef } from '@/wc/helper/ref';
import { Tooltip } from '@moneyforward/ap-frontend-components';
import classnames from 'classnames/bind';
import { CSSProperties, FC, memo, ReactNode } from 'react';
import styles from './TooltipCell.module.scss';

const cx = classnames.bind(styles);

type StyleWithLineClamp = CSSProperties & { '--line-clamp'?: number };

export type TooltipCellProps = {
  title: string | null | undefined;
  children: ReactNode;
  wrapperClassName?: string;
  className?: string;
  // When set, the cell truncates to this many lines instead of the default
  // single-line ellipsis. Switches to a -webkit-box layout.
  lineClamp?: number;
};

export const TooltipCell: FC<TooltipCellProps> = memo(
  ({ title, children, wrapperClassName, className, lineClamp }) => {
    const container = useGlobalContainerRef();

    const multiLineStyle: StyleWithLineClamp | undefined =
      typeof lineClamp === 'number' ? { '--line-clamp': lineClamp } : undefined;
    const isMultiLine = multiLineStyle !== undefined;

    return (
      <Tooltip
        title={title ?? ''}
        getPopupContainer={container}
        overlayClassName={cx(styles['tooltipOverlay'])}
      >
        <div
          className={cx(
            isMultiLine ? styles['multiLineWrapper'] : styles['wrapper'],
            wrapperClassName,
            className
          )}
          style={multiLineStyle}
        >
          {children}
        </div>
      </Tooltip>
    );
  }
);

TooltipCell.displayName = 'TooltipCell';
